/**
 * DefineDecompositionTabs — Step 4 view-switcher tab bar.
 *
 * Sits at the top of the Workbench center area and lets the user switch
 * between four views of the same underlying decomposition:
 *
 *   Domains  — Step 5 (Kanban / domain board) — placeholder for now
 *   Services — existing Define Services workbench (DEFAULT)
 *   Graph    — Step 6 (graph view with domain coloring) — placeholder
 *   List     — Step 7 (TanStack Table) — placeholder
 *
 * Step 4 scope: scaffold only.
 *   - Renders the tab bar with the four buttons
 *   - Reports tab clicks via onChange(viewMode)
 *   - Visual style mirrors the existing .dc-tab / .dc-tab-bar conventions
 *
 * Companion docs:
 *   ~/Desktop/_30Apr_New_Arch_Change/2026-04-30_define_decomposition_ux_design.md
 *   ~/Desktop/_30Apr_New_Arch_Change/2026-04-30_define_decomposition_implementation_steps.md
 */

import React from 'react'
import { LayoutGrid, Boxes, Network, List } from 'lucide-react'
import {
  DECOMPOSITION_VIEW_MODES,
  DEFAULT_DECOMPOSITION_VIEW_MODE,
} from './decompositionViewModes'

const TABS = [
  { id: 'domains',  label: 'Domains',  icon: LayoutGrid, hidden: true }, // redundant in v3 — graph clustering handles paragraph grouping
  { id: 'services', label: 'Services', icon: Boxes      },
  { id: 'graph',    label: 'Graph',    icon: Network,   hidden: true },
  { id: 'list',     label: 'List',     icon: List,      hidden: true },
]

export default function DefineDecompositionTabs({ value, onChange }) {
  const safeValue = DECOMPOSITION_VIEW_MODES.includes(value)
    ? value
    : DEFAULT_DECOMPOSITION_VIEW_MODE

  return (
    <div
      className="dc-tab-bar dc-decomp-subtab-bar"
      role="tablist"
      aria-label="Decomposition view"
    >
      {TABS.filter(tab => !tab.hidden).map(tab => {
        const Icon = tab.icon
        const isActive = safeValue === tab.id
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-controls={`dc-decomp-panel-${tab.id}`}
            className={`dc-tab ${isActive ? 'active' : ''}`}
            onClick={() => onChange?.(tab.id)}
          >
            <Icon size={14} />
            <span>{tab.label}</span>
          </button>
        )
      })}
    </div>
  )
}
